import type { FC } from "react";

import RadioSelect from "app/components/React/RadioSelect/radioSelect";
import { DomainsFilter } from "app/pages/website-analysis/traffic-sources/display-ads/common/filters/DomainFilter";

import { RadioSelectionContainer } from "../styledComponents";

interface IDomain {
    name: string;
    displayName: string;
    icon: string;
}

interface IRadioFilters {
    radioButtonItems: Array<{
        id: string;
        text: string;
        tooltip: string;
        trackingName: string;
    }>;
    selectedRadioButton: string;
    onRadioButtonClicked: (item: string) => void;
}

interface IFiltersSectionProps {
    isCompare: boolean;
    domainsList: IDomain[];
    currentDomain: string;
    onDomainChange: (newKey: { text: string }) => void;
    radioFilters: IRadioFilters;
}

export const FiltersSection: FC<IFiltersSectionProps> = ({
    isCompare,
    domainsList,
    currentDomain,
    onDomainChange,
    radioFilters,
}) => {
    const shouldShowDomainFilter = isCompare && domainsList.length > 0;

    return (
        <RadioSelectionContainer>
            {shouldShowDomainFilter ? (
                <DomainsFilter
                    onDomainFilterChange={onDomainChange}
                    selectedDomain={currentDomain}
                    domains={domainsList}
                />
            ) : null}
            <RadioSelect
                items={radioFilters.radioButtonItems}
                selected={radioFilters.selectedRadioButton}
                onSelect={radioFilters.onRadioButtonClicked}
            />
        </RadioSelectionContainer>
    );
};
